import * as bootstrap from 'bootstrap'
import $ from 'jquery'

function initMetisMenu() {
    // metis menu
    $("#side-menu").metisMenu();

    // When clicking a top-level parent menu link with a valid navigation URL, navigate directly
    $(document).on('click', '#side-menu > li > a.has-arrow', function (e) {
        var href = $(this).attr('href');
        if (href && href !== '#' && href !== 'javascript:void(0);' && !href.startsWith('javascript:')) {
            window.location.href = href;
        }
    });
}

    let toggle_sidebar = async (event) => {
        // event.preventDefault();
        $('body').toggleClass('sidebar-enable');

        if ($(window).width() >= 992) {
            $('body').toggleClass('vertical-collpsed');
        } else {
            $('body').removeClass('vertical-collpsed');
        }
    }

    const hide_sidebar = async (event) => {
        // event.preventDefault();
        if ($(window).width() < 992) {
            $('body').removeClass('sidebar-enable');
        }
    }

    function initLeftMenuCollapse() {
        $(document).on('click', '#vertical-menu-btn', function (event) {
            event.preventDefault();
            event.stopPropagation();
            toggle_sidebar(event);
        });

        $('#page-topbar').on('click', function (event) {
            if (!$(event.target).closest('#vertical-menu-btn').length) {
                hide_sidebar(event);
            }
        });

        $('.main-content').on('click', function (event) {
            hide_sidebar(event);
        });
    }

    function initActiveMenu() {
        var currentUrl = window.location.href.split('#')[0];
        var currentPath = window.location.pathname;
        var currentSearch = window.location.search;

        var exactMatch = null;
        var pathMatches = [];

        // Check sub-menu links first so they take precedence over parent .has-arrow links
        $("#sidebar-menu ul.sub-menu a").each(function () {
            var linkHref = (this.href || '').split('#')[0];
            if (!linkHref || linkHref === "javascript:void(0);" || linkHref.startsWith("javascript:")) {
                return;
            }

            if (linkHref === currentUrl) {
                exactMatch = $(this);
                return false;
            }

            if (this.pathname === currentPath) {
                pathMatches.push({
                    $el: $(this),
                    search: this.search || ''
                });
            }
        });

        // If no sub-menu matched, check top-level direct links
        if (!exactMatch && pathMatches.length === 0) {
            $("#sidebar-menu > ul > li > a:not(.has-arrow)").each(function () {
                var linkHref = (this.href || '').split('#')[0];
                if (!linkHref || linkHref === "javascript:void(0);" || linkHref.startsWith("javascript:")) {
                    return;
                }

                if (linkHref === currentUrl) {
                    exactMatch = $(this);
                    return false;
                }

                if (this.pathname === currentPath) {
                    pathMatches.push({
                        $el: $(this),
                        search: this.search || ''
                    });
                }
            });
        }

        var $matchedLink = null;
        if (exactMatch && exactMatch.length) {
            $matchedLink = exactMatch;
        } else if (pathMatches.length > 0) {
            if (currentSearch) {
                var searchMatch = pathMatches.find(function (item) {
                    return item.search && currentSearch.includes(item.search);
                });
                if (searchMatch) {
                    $matchedLink = searchMatch.$el;
                }
            }
            if (!$matchedLink) {
                var defaultMatch = pathMatches.find(function (item) {
                    return !item.search;
                });
                $matchedLink = defaultMatch ? defaultMatch.$el : pathMatches[0].$el;
            }
        }

        if ($matchedLink && $matchedLink.length) {
            $matchedLink.addClass("active");
            $matchedLink.parent().addClass("mm-active"); // add active to li of the current link
            $matchedLink.parent().parent().addClass("mm-show");
            $matchedLink.parent().parent().prev().addClass("mm-active"); // add active class to an anchor
            $matchedLink.parent().parent().parent().addClass("mm-active");
            $matchedLink.parent().parent().parent().parent().addClass("mm-show"); // add active to li of the current link
            $matchedLink.parent().parent().parent().parent().parent().addClass("mm-active");
        }
    }

    function initMenuItemScroll() {
        // focus active menu in left sidebar
        $(document).ready(function () {
            if ($("#sidebar-menu").length > 0 && $("#sidebar-menu .mm-active .active").length > 0) {
                var activeMenu = $("#sidebar-menu .mm-active .active").offset().top;
                if (activeMenu > 300) {
                    activeMenu = activeMenu - 300;
                    $(".vertical-menu .simplebar-content-wrapper").animate({ scrollTop: activeMenu }, "slow");
                }
            }
        });
    }

    function initHoriMenuActive() {
        $(".navbar-nav a").each(function () {
            var pageUrl = window.location.href.split(/[?#]/)[0];
            if (this.href == pageUrl) {
                $(this).addClass("active");
                $(this).parent().addClass("active");
                $(this).parent().parent().addClass("active");
                $(this).parent().parent().parent().addClass("active");
                $(this).parent().parent().parent().parent().addClass("active");
                $(this).parent().parent().parent().parent().parent().addClass("active");
                $(this).parent().parent().parent().parent().parent().parent().addClass("active");
            }
        });
    }

    function initFullScreen() {
        $('[data-bs-toggle="fullscreen"]').on("click", function (e) {
            e.preventDefault();
            $('body').toggleClass('fullscreen-enable');
            if (!document.fullscreenElement && /* alternative standard method */ !document.mozFullScreenElement && !document.webkitFullscreenElement) {  // current working methods
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        });
        document.addEventListener('fullscreenchange', exitHandler);
        document.addEventListener("webkitfullscreenchange", exitHandler);
        document.addEventListener("mozfullscreenchange", exitHandler);
        function exitHandler() {
            if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
                console.log('pressed');
                $('body').removeClass('fullscreen-enable');
            }
        }
    }

    function initRightSidebar() {
        // right side-bar toggle
        $('.right-bar-toggle').on('click', function (e) {
            $('body').toggleClass('right-bar-enabled');
        });

        $(document).on('click', 'body', function (e) {
            if ($(e.target).closest('.right-bar-toggle, .right-bar').length > 0) {
                return;
            }

            $('body').removeClass('right-bar-enabled');
            return;
        });
    }

    function initDropdownMenu() {
        if (document.getElementById("topnav-menu-content")) {
            var elements = document.getElementById("topnav-menu-content").getElementsByTagName("a");
            for (var i = 0, len = elements.length; i < len; i++) {
                elements[i].onclick = function (elem) {
                    var anchor = elem.currentTarget || (elem.target && elem.target.closest ? elem.target.closest('a') : elem.target);
                    if (!anchor || anchor.getAttribute("data-bs-toggle") === "dropdown") {
                        return;
                    }
                    if (anchor.getAttribute("href") === "#") {
                        if (anchor.parentElement) {
                            anchor.parentElement.classList.toggle("active");
                        }
                        if (anchor.nextElementSibling) {
                            anchor.nextElementSibling.classList.toggle("show");
                        }
                    }
                }
            }
            window.addEventListener("resize", updateMenu);
        }
    }

    function updateMenu() {
        var elements = document.getElementById("topnav-menu-content").getElementsByTagName("a");
        for (var i = 0, len = elements.length; i < len; i++) {
            if (elements[i].parentElement.getAttribute("class") === "nav-item dropdown active") {
                elements[i].parentElement.classList.remove("active");
                if (elements[i].nextElementSibling !== null) {
                    elements[i].nextElementSibling.classList.remove("show");
                }
            }
        }
    }

    function initComponents() {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl, {
                container: 'body',
                popperConfig: function (defaultBsPopperConfig) {
                    return {
                        ...defaultBsPopperConfig,
                        strategy: 'fixed'
                    };
                }
            })
        });

        var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
        var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
            return new bootstrap.Popover(popoverTriggerEl)
        });

        var offcanvasElementList = [].slice.call(document.querySelectorAll('.offcanvas'))
        var offcanvasList = offcanvasElementList.map(function (offcanvasEl) {
            return new bootstrap.Offcanvas(offcanvasEl)
        })
    }

    function initPreloader() {
        const preloader = $('.preloader, #preloader');
        if (!preloader.length) {
            return;
        }

        let isHidden = false;
        const hidePreloader = () => {
            if (isHidden) return;
            isHidden = true;
            $('.status, #status').fadeOut(200);
            preloader.delay(100).fadeOut(300);
        };

        if (document.readyState === 'complete') {
            setTimeout(hidePreloader, 150);
        } else {
            $(window).on('load', function () {
                setTimeout(hidePreloader, 150);
            });
            // Fallback in case window load event is delayed or already occurred
            $(document).ready(function () {
                setTimeout(hidePreloader, 600);
            });
            setTimeout(hidePreloader, 1500);
        }
    }

    function initSettings() {
        if (window.sessionStorage) {
            var alreadyVisited = sessionStorage.getItem("is_visited");
            if (!alreadyVisited) {
                sessionStorage.setItem("is_visited", "light-mode-switch");
            } else {
                $(".right-bar input:checkbox").prop('checked', false);
                $("#" + alreadyVisited).prop('checked', true);
                // updateThemeSetting(alreadyVisited);
            }
        }
        // $("#light-mode-switch, #dark-mode-switch, #rtl-mode-switch, #dark-rtl-mode-switch").on("change", function (e) {
        //     updateThemeSetting(e.target.id);
        // });

        // show password input value
        $("#password-addon").on('click', function () {
            if ($(this).siblings('input').length > 0) {
                $(this).siblings('input').attr('type') == "password" ? $(this).siblings('input').attr('type', 'input') : $(this).siblings('input').attr('type', 'password');
            }
        })
    }

    // function updateThemeSetting(id) {
    //     if ($("#light-mode-switch").prop("checked") == true && id === "light-mode-switch") {
    //         $("html").removeAttr("dir");
    //         $("#dark-mode-switch").prop("checked", false);
    //         $("#rtl-mode-switch").prop("checked", false);
    //         $("#dark-rtl-mode-switch").prop("checked", false);
    //         $("#bootstrap-style").attr('href', 'assets/css/bootstrap.min.css');
    //         $("#app-style").attr('href', 'assets/css/app.min.css');
    //         sessionStorage.setItem("is_visited", "light-mode-switch");
    //     } else if ($("#dark-mode-switch").prop("checked") == true && id === "dark-mode-switch") {
    //         $("html").removeAttr("dir");
    //         $("#light-mode-switch").prop("checked", false);
    //         $("#rtl-mode-switch").prop("checked", false);
    //         $("#dark-rtl-mode-switch").prop("checked", false);
    //         $("#bootstrap-style").attr('href', 'assets/css/bootstrap-dark.min.css');
    //         $("#app-style").attr('href', 'assets/css/app-dark.min.css');
    //         sessionStorage.setItem("is_visited", "dark-mode-switch");
    //     } else if ($("#rtl-mode-switch").prop("checked") == true && id === "rtl-mode-switch") {
    //         $("#light-mode-switch").prop("checked", false);
    //         $("#dark-mode-switch").prop("checked", false);
    //         $("#dark-rtl-mode-switch").prop("checked", false);
    //         $("#bootstrap-style").attr('href', 'assets/css/bootstrap-rtl.min.css');
    //         $("#app-style").attr('href', 'assets/css/app-rtl.min.css');
    //         $("html").attr("dir", 'rtl');
    //         sessionStorage.setItem("is_visited", "rtl-mode-switch");
    //     } else if ($("#dark-rtl-mode-switch").prop("checked") == true && id === "dark-rtl-mode-switch") {
    //         $("#light-mode-switch").prop("checked", false);
    //         $("#rtl-mode-switch").prop("checked", false);
    //         $("#dark-mode-switch").prop("checked", false);
    //         $("#bootstrap-style").attr('href', 'assets/css/bootstrap-dark-rtl.min.css');
    //         $("#app-style").attr('href', 'assets/css/app-dark-rtl.min.css');
    //         $("html").attr("dir", 'rtl');
    //         sessionStorage.setItem("is_visited", "dark-rtl-mode-switch");
    //     }

    // }

    function initCheckAll() {
        $('#checkAll').on('change', function () {
            $('.table-check .form-check-input').prop('checked', $(this).prop("checked"));
        });
        $('.table-check .form-check-input').change(function () {
            if ($('.table-check .form-check-input:checked').length == $('.table-check .form-check-input').length) {
                $('#checkAll').prop('checked', true);
            } else {
                $('#checkAll').prop('checked', false);
            }
        });
    }

    function init() {
        initMetisMenu();
        initLeftMenuCollapse();
        initActiveMenu();
        initMenuItemScroll();
        initHoriMenuActive();
        initFullScreen();
        initRightSidebar();
        initDropdownMenu();
        initComponents();
        initSettings();
        initPreloader();
        Waves.init();
        initCheckAll();
    }

    init();
